import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import getTooltipTitle from "../../utils/getTooltip";
import getIcon from "../../utils/getIcon";
import { useTranslation } from "react-i18next";

function sortByDeviceTypesObjectReduce(data, deviceTypes) {
  const dataMap = {};
  data.forEach((item) => {
    dataMap[item[0]] = item[1];
  });

  return deviceTypes.map((type) => dataMap[type]);
}

const DeviceDescription = ({
  device,
  expandIdx,
  deviceDesc,
  sensorLatest,
  historyButtonOnClick,
}) => {
  const { t } = useTranslation();

  const isCurrentExpanded = expandIdx === device.sn;
  const isDeviceDescActive = deviceDesc?.parameters !== undefined;
  const isSensorLatestActive = sensorLatest?.values !== undefined;
  const deviceParam = deviceDesc?.parameters?.[0] ?? {};
  const deviceTypes = Object.keys(deviceParam);
  const deviceUnits = Object.values(deviceParam);
  const sensorData = sortByDeviceTypesObjectReduce(
    Object.entries(sensorLatest?.values?.["地表"] ?? {}),
    deviceTypes,
  );
  if (!isDeviceDescActive || !isSensorLatestActive) {
    return (
      <Collapse in={isCurrentExpanded}>
        <Divider sx={{ mt: 1 }} />
        <Box height='240px' display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Box display='flex' justifyContent='center'>
            <CircularProgress sx={{ mt: 1 }} />
          </Box>
        </Box>
      </Collapse>
    );
  }
  return (
    <>
      <Collapse in={isCurrentExpanded}>
        <Divider sx={{ mt: 1 }} />
        <Box height='240px' display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Box width='100%'>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    "& .MuiTableCell-root": {
                      height: "60px",
                    },
                  }}
                >
                  <TableCell align='left' sx={{ fontSize: 12, padding: "6px 12px" }}>
                    {t("devicedescription.type")}
                  </TableCell>
                  {deviceTypes.map((type) => (
                    <TableCell align='left' key={type} sx={{ fontSize: 12, padding: "6px 12px" }}>
                      <Box>
                        {getIcon(type)}
                        <Typography sx={{ fontSize: 10 }}>{getTooltipTitle(type, t)}</Typography>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontSize: 12, padding: "6px 12px" }}>
                    {t("devicedescription.unit")}
                  </TableCell>
                  {deviceUnits.map((typeInfo, index) => (
                    <TableCell
                      align='left'
                      sx={{ fontSize: 12, padding: "6px 12px" }}
                      key={`${typeInfo.id || typeInfo.unit}${index}`}
                    >
                      {typeInfo.unit === "" ? "/" : typeInfo.unit}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontSize: 12, padding: "6px 12px" }}>
                    {t("devicedescription.recentdata")}
                  </TableCell>
                  {sensorData.map((value, index) => (
                    <TableCell align='left' key={index} sx={{ fontSize: 12, padding: "6px 12px" }}>
                      {typeof value === "string"
                        ? isNaN(Number(value))
                          ? value
                          : Number(value).toFixed(2)
                        : typeof value === "number"
                          ? value.toFixed(2)
                          : value}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontSize: 12, padding: "6px 12px" }}>
                    {t("devicedescription.recordedat")}
                  </TableCell>
                  <TableCell
                    align='left'
                    colSpan={Object.values(deviceParam).length}
                    sx={{ fontSize: 12, padding: "6px 12px" }}
                  >
                    {sensorLatest?.datetime}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Box display='flex' flexDirection='row' gap={1}>
              <Button fullWidth variant='contained' onClick={historyButtonOnClick}>
                {t("devicedescription.devicehistory")}
              </Button>
              <Button disabled fullWidth variant='contained'>
                {t("devicedescription.editdevice")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </>
  );
};

export default DeviceDescription;
